/* eslint-disable extra-rules/no-commented-out-code */
import useInjectReducerAndSaga from '@tcp/core/src/utils/useInjectReducerAndSaga';

export default async () => {
  const [BuyItAgainReducer, BuyItAgainSaga, BuyItAgainBagPageReducer, BuyItAgainBagPageSaga] =
    await Promise.all([
      import(/* webpackChunkName: "buy-it-again-page" */ './BuyItAgain.reducer'),
      import(/* webpackChunkName: "buy-it-again-page" */ './BuyItAgain.saga'),
      import(
        /* webpackChunkName: "buy-it-again-bag-page" */ '@tcp/core/src/components/features/CnC/BuyItAgainBagPage/container/BuyItAgainBagPage.reducer'
      ),
      import(
        /* webpackChunkName: "buy-it-again-bag-page" */ '@tcp/core/src/components/features/CnC/BuyItAgainBagPage/container/BuyItAgainBagPage.saga'
      ),
    ]);
  useInjectReducerAndSaga(
    { key: 'buyItAgain', reducer: BuyItAgainReducer.default },
    { key: 'BuyItAgainSaga', saga: BuyItAgainSaga.default }
  );
  useInjectReducerAndSaga(
    { key: 'buyItAgain', reducer: BuyItAgainBagPageReducer.default },
    { key: 'BuyItAgainBagPageSaga', saga: BuyItAgainBagPageSaga.default }
  );
  return null;
};
